import React, {Component} from 'react';
import {ControlLabel} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../utilities/TabUtilities";
import tabgrid from "../../../../utilities/TabGrid";
import {Link} from "react-router-dom";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import moment from 'moment'

export default class KlienciTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.renderDokumentDoUlgi = this.renderDokumentDoUlgi.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        if (row.idKl !== 1)
            return (
                <div>
                    <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                        <TopButtonPointAction onClick={() => {
                        }} titleContent={'Pokaż stronę klienta'} buttonColor={'default'} buttonIcon={'fa fa-external-link'}/>
                    </Link>
                    <TopButtonPointEdit onClick={() => {
                        this.props.handleEdytuj(row)
                    }} titleContent={'Edytuj klienta'}/>
                    <TopButtonPointRemove onClick={() => {
                        this.props.handleUsun(row)
                    }} titleContent={'Usuń klienta'}/>
                </div>
            )
    }

    formatUlica(cell, row) {
        if (cell) {
            return <span>{cell}, {Boolean(row.nrDomu) ? row.nrDomu : ''}{Boolean(row.nrMieszk) ? '/' + row.nrMieszk : ''}</span>
        }
    }

    renderZdjecie(cell, row) {
        if (Boolean(cell)) {
            return <div><img src={'data:image/jpg;base64,' + cell} style={{width: '40px'}}/></div>
        }
    }

    renderWaznyDo(value) {
        if (Boolean(value)) {
            if (DateAndTimeFormat.formatYYYYMMDD(moment()) > value) {
                return <span style={{color: 'firebrick'}}> {value} <i className={'fa fa-exclamation-circle'}></i></span>
            }
            else return value
        }
        else return ''
    }

    renderDokumentDoUlgi(cell, row) {
        if (Boolean(cell) && cell !== ' ')
            return <div>
                <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                    <div>
                        <span>
                        <span style={{color: '#666'}}><i className={'fa fa-id-card-o'}></i> Nr. dokumentu:</span> {cell}
                        </span>
                        <span style={{marginLeft: '5px'}}>
                                    {Boolean(row.nrDokSprawdzony) ? <span style={{color: 'forestgreen'}}><i className={'fa fa-check'}></i>
                                            <span style={{fontSize: '10px'}}> potwierdzony</span></span> :
                                        <span style={{color: 'firebrick'}}>
                                        <i className={'fa fa-times'}></i>
                                        <span style={{fontSize: '10px'}}> brak potwierdzenia</span></span>
                                    }
                         </span>
                    </div>
                    <div>
                        <span>
                            <span style={{color: '#666'}}><i className={'fa fa-calendar'}></i> Ważny do:</span> {this.renderWaznyDo(row.nrDokWaznyDo)}
                        </span>
                    </div>
                </Link>
            </div>
        else return cell
    }

    render() {

        const options = {
            noDataText: 'Brak pasujących rekordów',
            sizePerPageList: [10, 15, 30, 50, 100],
            sizePerPage: this.props.ilosc,
            page: this.props.strona,
            onSizePerPageList: this.props.onSizePerPageList,
            onPageChange: this.props.onPageChange,
        };
        return (
            <div>
                <div className={'pull-right'} style={{marginTop: '15px'}}>
                    <ControlLabel>Ilość klientów: {this.props.pageable.totalElements}</ControlLabel>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                                    fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                    remote={true}
                                    pagination={true}
                    >
                        <TableHeaderColumn dataField='idKl' isKey thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={(cell, row) => {
                                               return <span className={'label label-ebus-primary'}>{cell}</span>
                                           }}
                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwisko'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                        >Nazwisko</TableHeaderColumn>
                        <TableHeaderColumn dataField='imie'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                        >Imie</TableHeaderColumn>{/*
                        <TableHeaderColumn dataField='pesel'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >PESEL</TableHeaderColumn>*/}
                        <TableHeaderColumn dataField='nrDok'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           dataFormat={this.renderDokumentDoUlgi}
                        >Dokument uprawniający do ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='nrTel'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >Telefon</TableHeaderColumn>
                        <TableHeaderColumn dataField='email'
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                        >Email</TableHeaderColumn>
                        <TableHeaderColumn dataField='ulica'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatUlica}
                        >Ulica</TableHeaderColumn>
                        <TableHeaderColumn dataField='miejscowosc'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >Miejscowość</TableHeaderColumn>
                        <TableHeaderColumn dataField='idKl'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.renderButtonyAkcji}
                        >{TabUtilities.returnAkcjeEdytujUsunPlusDodatkowaHtml('Zobacz stronę', '#333')}</TableHeaderColumn>
                    </BootstrapTable>

                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/klienci/components/KlienciTable.js